<main  [formGroup]="parentFormGroup" class="project">
  <ng-container formArrayName="acPf">
    <ng-container *ngFor="let pf of acPf?.controls; let i_pf = index"  [formGroupName]="i_pf">
      <mat-accordion class="example-headers-align mb-0" [togglePosition]="'before'" *ngIf="currentItem[i_pf] as variable">
        <mat-expansion-panel class="session tr-{{i_pf % 2}} mb-0" [disabled]="variable?.pfIndicators?.length == 0">
          <mat-expansion-panel-header  class="session-title  py-2 ">
            <mat-panel-title class="d-flex justify-content-between row">
              <div class="col-11 col-md-4 col-lg-7 d-flex">
                
                <div class="">
                  <input type="checkbox" class="me-3" [checked]="variable?.checkeds" formControlName="checkeds" title="Selecione ao menos um Item deste projetos"  (change)="onCheckStatus()"/>
                  
                </div>
                {{variable?.title}}
              </div>
              <div class="col-3  col-md-1 col-lg-1">
                <span>{{variable?.year}}.{{variable?.code}}</span>
              </div>
              <div class="col-4 col-md-4 col-lg-2 responsavel">
                <div class="tag strategic" *ngIf="variable.level_priority == 1">ESTRATÉGICO</div>
                <div class="tag irfe" *ngIf="variable.irfe_enabled_id == 1">IRFE</div>
                <div class="tag ircp" *ngIf="variable.ircp_enabled_id == 1">IRCP</div>
                <div class="tag plano_rio_grande" *ngIf="variable.pf_program?.id">PLANO RIO GRANDE</div>
              </div>
              <div class="col-5 col-md-2 d-flex justify-content-end">
                <button class="btn btn-font-icon ms-1" type="button" (click)="$event.stopPropagation(); changeAllCheck(pf, true)"
                  alt="Selecionar todos" title="Selecionar tudo">
                  select_check_box
                </button>
                <button class="btn btn-font-icon ms-1" type="button" (click)="$event.stopPropagation(); changeAllCheck(pf, false)"
                  alt="Desselecionar todos" title="Desmarcar tudo">
                  disabled_by_default
                </button>
                <button class="btn btn-font-icon ms-1" type="button" (click)="$event.stopPropagation(); restartCheck(pf,i_pf)"
                  alt="Desselecionar todos" title="Desfazer mudanças">
                  replay
                </button>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-itens-pf-indicators *ngIf="currentItem[i_pf]['pfIndicators'] as pfIndicators"
            [parentFormGroup]="pf"
            [currentItem]="pfIndicators" class="system-table indicador-table"
            (checkStatus)="onCheckStatus(pf)">
          </app-itens-pf-indicators>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
  </ng-container>
</main>
